<template>
  <div class="home-baike" v-if="count > 0">
    <div class="left">
      <div class="title">
        <span class="zh">商品百科</span>
        <span class="en">/Product Encyclopedia</span>
      </div>
      <div
        class="content"
      >在商品百科模块，您可以了解到永辉的商品在田野湖泊的种养殖环境、生长周期、加工流程、存储方式，探索商品背后的故事，饕餮食客们还可以发掘商品的品鉴烹饪方法。</div>
      <div class="link" @click="goto('/product/list')">
        {{count}} 条商品百科
        <!-- <div></div> -->
        <img src="@/assets/index/全部商品2.png" />
      </div>
    </div>
    <div class="right" @mousewheel.prevent="onMouseWheel">
      <div class="left" @click="goto('/product/baike/' + list[currentIndex].id, true)">
        <img :src="util.getFirstImage(list[currentIndex].images, '336x336')" />
      </div>
      <div class="right">
        <img :src="util.getFirstImage(list[currentIndex].images, '336x336')" />

        <div class="index">
          <span class="current">{{currentIndex + 1}}</span>
          <span class="total">/{{list.length}}</span>
        </div>

        <div class="intro-list" :style="`transform: translateY(${top}px);`">
          <div class="intro" v-for="(item, index) in list" :key="index">
            <div class="title">{{item.name}}</div>
            <div class="content">{{item.features}}</div>
            <div class="detail" @click="goto('/product/baike/' + item.id, true)">查看详情 ></div>
          </div>
        </div>

        <div class="scroll">
          <div class="cursor" :style="`transform: translateY(${cursorTop}px);`"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Prev from "./Prev";
import Next from "./Next";
export default {
  name: "HomeBaike",
  components: {
    Prev,
    Next
  },
  props: {
    list: {
      type: Array,
      default: []
    },
    count: Number
  },
  data() {
    return {
      currentIndex: 0,
      size: 336,
      dy: 0
    };
  },
  computed: {
    top: function() {
      return -this.size * this.currentIndex;
    },
    cursorTop: function() {
      return (144 / (this.list.length - 1)) * this.currentIndex;
    }
  },
  created() {
    setInterval(this.play, 5000);
  },
  methods: {
    play() {
      if (this.currentIndex < this.list.length - 1) {
        this.currentIndex += 1;
      } else {
        this.currentIndex = 0;
      }
    },
    onMouseWheel(e) {
      console.log(e);

      this.dy += e.wheelDeltaY;
      // 滚轮向下
      if (this.dy < -100) {
        this.onNext();
        this.dy = 0;
      }
      // 滚轮向上
      if (this.dy > 100) {
        this.onPrev();
        this.dy = 0;
      }
    },
    onPrev() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
      }
    },
    onNext() {
      if (this.currentIndex < this.list.length - 1) {
        this.currentIndex += 1;
      }
    },
    goto(path, open) {
      if (open) {
        window.open(path);
      } else {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.home-baike {
  width: 1100px;
  height: 340px;
  margin: 100px auto;

  .arrow {
    position: absolute;
    top: 36px;
  }

  .arrow-left {
    left: 0px;
  }

  .arrow-right {
    right: 0px;
  }

  .left {
    display: inline-block;
    width: 300px;
    margin-right: 125px;
    vertical-align: top;
    cursor: pointer;

    .title {
      .zh {
        font-size: 28px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(51, 51, 51, 1);
        line-height: 31px;

        margin-right: 20px;
      }

      .en {
        font-size: 14px;
        font-weight: 200;
        color: rgba(132, 135, 145, 1);
        line-height: 20px;
      }
    }

    .content {
      margin: 36px 0;
      font-size: 16px;
      font-weight: 200;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }

    .link {
      display: inline-block;
      height: 36px;
      line-height: 36px;
      padding: 0 10px;
      border: 1px solid rgba(132, 135, 145, 0.5);
      font-size: 12px;
      font-weight: 400;
      color: rgba(132, 135, 145, 1);
      cursor: pointer;
      img {
        width: 12px;

        margin-left: 24px;
      }
    }

    .link:hover {
      border: 1px solid rgba(51, 51, 51, 1);
      background: rgba(51, 51, 51, 1);
      color: white;
    }
  }

  .right {
    display: inline-block;
    width: 672px;

    .left {
      display: inline-block;
      width: 336px;
      height: 336px;
      margin: 0;

      img {
        width: 336px;
        height: 336px;
      }
    }

    .right {
      display: inline-block;
      width: 336px;
      height: 336px;
      overflow: hidden;

      position: relative;

      img {
        z-index: -1;
        position: absolute;
        width: 336px;
        height: 336px;
        filter: blur(50px);
      }

      .index {
        z-index: 2;
        position: absolute;
        right: 0;
        height: 36px;
        line-height: 35px;
        padding: 0 10px;
        background: black;

        .current {
          color: white;
          font-size: 22px;
          font-family: "DINMedium";
        }

        .total {
          color: #6d7278;
          font-size: 14px;
          font-family: "DINMedium";
        }
      }

      .intro-list {
        transition: all 0.6s ease-out;
        width: 336px;
      }

      .intro {
        width: 276px;
        height: 276px;
        padding: 30px;
        background: rgba(0, 0, 0, 0.7);
        .title {
          font-size: 22px;
          font-family: "FZQKBYSJW";
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          line-height: 24px;
        }

        .content {
          margin-top: 30px;
          height: 200px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 26px;
          opacity: 0.7;
        }

        .detail {
          cursor: pointer;
          text-align: right;
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 17px;
          opacity: 0.7;
        }
      }

      .scroll {
        z-index: 2;
        position: absolute;
        top: 70px;
        right: 10px;
        width: 3px;
        height: 170px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 2px;

        .cursor {
          transition: all 0.6s ease-out;
          width: 3px;
          height: 26px;
          background: rgba(109, 114, 120, 1);
          border-radius: 2px;
        }
      }
    }
  }
}
</style>